'use strict';

angular.module('randomization')
    .controller('RandomizationBlockController', ['RandomizationBlocksService', 'CrdConfigurationService', 'ShareCrfApiErrorCodes', function(RandomizationBlocksService, CrdConfigurationService, ShareCrfApiErrorCodes) {
        var vm = this;

        vm.data = undefined;

        vm.branches = {};
        angular.forEach(CrdConfigurationService.getRandomization().getArms(), function(branchData) {
            vm.branches[branchData.id] = branchData;
        });

        // También se guardan los brazos originales del bloque, para elementos ya asignados o eliminados
        vm.blockBranches = {};

        vm.entityLabel = CrdConfigurationService.getLabelSingular();

        vm.hasCohort = false;

        vm.$onInit = function() {
            RandomizationBlocksService.getBlock(parseInt(vm.blockId, 10))
                .then(function(block) {
                    vm.data = block;

                    _setBlockBranches(block);

                    vm.hasCohort = angular.isDefined(block.cohort) && Object.keys(block.cohort).length > 0;
                })
                .catch(function(error) {
                    vm.data = undefined;
                    vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                });
        };

        function _setBlockBranches(block) {
            angular.forEach(block.config.branches, function(branchData) {
                vm.blockBranches[branchData.id] = branchData;
            });
        }
    }]);
